<template>
  <div id="wishlist-list-component">
    <div class="row row-cards">
      <template v-if="isNotFound(items) && !busy">
        <span class="items-not-found">Ничего не найдено</span>
      </template>
      <template v-else>
        <div class="col-lg-4 col-sm-6" v-for="item in items" :key="item.id">
          <div class="card">
            <div class="wishlist-items">
              <div class="close-full-show" v-if="isMoreShow(item.id)" @click.prevent="onMoreHide(item.id)">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M18 6l-12 12"></path>
                  <path d="M6 6l12 12"></path>
                </svg>
              </div>
              <div class="card-img-top card-img-hover" @click.prevent="onMoreShowHide(item.id)" :class="{ 'card-img-top_show': isMoreShow(item.id) }">
                <div class="row">
                  <div class="col-6">
                    <img :src="item.image(500, 500)" class="img-card">
                  </div>
                  <div class="col-6">
                    <div class="post-info" :class="{ 'no-badge': !hasBadge('item') }">
                      <ul>
                        <li v-if="item.hasCategory()">{{ item.categoryName }} <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-folders"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M9 3h3l2 2h5a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"></path><path d="M17 16v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"></path></svg></li>
                        <li v-if="item.hasCurrency()">{{ item.currencyAlias }} <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-coins"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 14c0 1.657 2.686 3 6 3s6 -1.343 6 -3s-2.686 -3 -6 -3s-6 1.343 -6 3" /><path d="M9 14v4c0 1.656 2.686 3 6 3s6 -1.344 6 -3v-4" /><path d="M3 6c0 1.072 1.144 2.062 3 2.598s4.144 .536 6 0c1.856 -.536 3 -1.526 3 -2.598c0 -1.072 -1.144 -2.062 -3 -2.598s-4.144 -.536 -6 0c-1.856 .536 -3 1.526 -3 2.598" /><path d="M3 6v10c0 .888 .772 1.45 2 2" /><path d="M3 11c0 .888 .772 1.45 2 2" /></svg></li>
                        <li v-if="item.hasWishBudget()">{{ item.wishBudget }} <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-pig-money"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M15 11v.01" /><path d="M5.173 8.378a3 3 0 1 1 4.656 -1.377" /><path d="M16 4v3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342c-.336 .95 -.907 1.8 -1.658 2.473v2.027a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l0 -.027a6 6 0 0 1 4 -10.473h2.5l4.5 -3" /></svg></li>
                        <li>{{ item.privacyText }} <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-eye"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path><path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path></svg></li>
                        <li v-if="item.hasCntWishlists()">{{ item.cntWishlists }} <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-link"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 15l6 -6" /><path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" /><path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" /></svg></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body post-item" @click="onMoreShow(item.id)">
                <div class="card-info"></div>
                <div class="text-muted title-post">{{ item.wishName }}</div>
                <div class="text-muted text-long" v-show="isMoreShow(item.id)" v-html="item.wishDesc"></div>
                <div class="text-muted card-text-sh" v-show="!isMoreShow(item.id)" v-html="item.wishDesc"></div>
                <div class="my-2">
                  <template v-if="item.isNotModerate">
                    <div class="row">
                      <div class="col-6">
                        <router-link :to="{ name: 'WishlistWishUpdate', params: { id: item.id } }" class="edit-post toggle-show-post" @click.prevent="onMoreShow(item.id)">Редактировать</router-link>
                      </div>
                      <div class="col-6">
                        <a href="#" class="edit-post toggle-show-post" @click.prevent="onModerate(item.id)">Проверить</a>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <router-link :to="{ name: 'WishlistWishUpdate', params: { id: item.id } }" class="edit-post toggle-show-post" @click.prevent="onMoreShow(item.id)">Редактировать</router-link>
                  </template>
                </div>
              </div>
              <div class="card-footer">
                <div class="d-flex align-items-center">
                  <span class="avatar me-3" :style="{ backgroundImage: 'url(' + item.userAvatar(60) + ')' }"></span>
                  <div class="author">
                    <template v-if="item.hasUser()">
                      <div class="author__name">{{ item.userName }}</div>
                    </template>
                  </div>
                  <div class="ms-auto text-right">
                    <div>Создано:</div>
                    <div class="text-muted" v-html="item.formattedCreatedDate"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="loader-posts">
        <div class="spinner-border" v-show="busy"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineOptions, ref, watch} from "vue"
import Helper from "@/services/Helper"
import Api from "./Api"
import { WishItemPresenter } from "./WishItemPresenter"
import Notify from "@/services/Notify"

defineOptions({
  name: "WishlistList"
})

const props = defineProps({
  query: {
    type: Object,
    required: true
  },
  clearResult: {
    type: Boolean,
    required: true
  }
})

const emit = defineEmits(["onRender"])
const busy = ref(false)
const items = ref([])
const eofItems = ref(false)
const countItems = ref(0)
const actions = ref([])

watch(() => props.query, (newQuery) => {
  busy.value = true
  if (props.clearResult) {
    clearResult()
  }
  load(newQuery)
})

function clearResult() {
  eofItems.value = false
  countItems.value = 0
  items.value = []
}

function load(query, offset = null) {
  if (offset !== null) {
    query.offset = offset
  }
  getApi(query)
      .then((resp) => {
        const data = resp.data

        const presenterItems = (data.items || []).map(item => new WishItemPresenter(item))
        items.value.push(...presenterItems)

        if (data.items.length === 0) {
          eofItems.value = true
        }
        
        countItems.value = data?.params?.cnt ?? 0
        loadFinal(data.items)
      })
      .finally(() => {
        busy.value = false
        emit("onRender", {
          "oef_items": eofItems.value,
          "count_items": countItems.value
        })
      })
}

function getApi(query) {
  return Api.items(query)
}

function loadFinal(/*items*/) {
  // Логика функции
}

function isNotFound(currentItems) {
  return Helper.isEmptyObject(currentItems)
}

function isMoreShow(post_id) {
  return actions.value[post_id]?.show === true
}

function onMoreHide(post_id) {
  actions.value[post_id] = { show: false }
}
function onMoreShowHide(post_id) {
  actions.value[post_id] = {
    show: !isMoreShow(post_id)
  }
}
function onMoreShow(post_id) {
  actions.value[post_id] = { show: true }
}
function hasBadge() {
  return false
}

function reload() {
  clearResult()
  load(props.query, 0)
}

function onModerate(wishId) {
  if (confirm("Вы действительно хотите промодерировать желание?")) {
    Api.moderate(wishId).then(() => {
      Notify.success("Проверено")
      reload()
    })
  }
}
</script>

<style scoped src="./style.css"/>
